import { Component, OnInit, forwardRef, Input, ViewChild, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ConfirmationService, DialogService, DynamicDialogRef, MessageService } from 'primeng/primeng';
import { environment } from '../../../../../environments/environment';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { VsFileUploadService } from '../services/file-upload.service';
import { SecondPageEditBase } from '../../../classes/base/second-page-edit-base';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { FileType } from '../../../../dapfood/common/constant';

@Component({
  selector: 'app-hq-file-view-comment',
  templateUrl: './hq-file-view-comment.component.html',
  styleUrls: ['./hq-file-view-comment.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HqFileViewCommentComponent),
      multi: true
    }
  ]
})
export class HqFileViewCommentComponent extends SecondPageEditBase implements OnInit, ControlValueAccessor {
  disabled = false;
  listUploaded: any[];
  progressValue = 0;
  ref: DynamicDialogRef;

  @Input() noDelete = false;
  @Input() chooseLabel = 'Chọn file';
  @Input() multiple = false;
  @Input() styleButton = false;
  @Input() defaultImage = false;
  @Input() showIconOnly = false;
  @Input() icon = 'fa-light fa-upload';
  @Input() viewOnly = false;
  @Input() fileType = '';    // '' , image/* , video/* , 

  @ViewChild(FileViewerComponent) _FileViewerComponent: FileViewerComponent;

  constructor(
    protected _injector: Injector,
    private confirmationService: ConfirmationService,
    private _fileUploadService: VsFileUploadService,
    public dialogService: DialogService,
  ) {
    super(null, _injector);
  }

  ngOnInit() {
  }

  onChangeControl = (obj: any) => { };
  onTouched = () => { };

  writeValue(obj: any): void {
    this.listUploaded = [];
    if (obj) {
      this.listUploaded = obj.split(",");

      this._fileUploadService.GetsByIds(obj).then(rs => {
        if (rs.status) {
          this.listUploaded = rs.data;

        }
      }).catch(err => {
        console.log('Có lỗi xảy ra, vui lòng thử lại ' + err);
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeControl = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  deleteFile(id) {
    this.confirmationService.confirm({
      message: 'Bạn có chắc chắn muốn xóa file này không ?',
      accept: () => {
        const fileToRemove = this.listUploaded.findIndex(x => x.id === id);
        this.listUploaded.splice(fileToRemove, 1);
        let files = this.listUploaded.map(x => x.id).join(",");
        this.onChangeControl(files);
        this.writeValue(files);
      }
    });
  }

  viewFile(item) {
    // Nếu file là hình ảnh hoặc vido thì dùng FileViewer, Nếu là tài liệu thì dùng VsFileViewer
    if (item.type == FileType.Image || item.type == FileType.Video) {
      this.ref = this.dialogService.open(FileViewerComponent, {
        data: {
          file: this.listUploaded.find(s => s.id == item.id),
          listFile: this.listUploaded
        },
        showHeader: false,
        width: '100%',
        height: 'calc(100vh)',
        styleClass: "vs-modal",
        contentStyle: { 'overflow': 'auto', 'position': 'relative' },
        baseZIndex: 1100,
        closeOnEscape: true,
      });
    }
    else {
      this.ref = this.dialogService.open(DocumentViewerComponent, {
        data: item,
        showHeader: true,
        header: item.fileName,
        width: '100%',
        height: 'calc(100vh - 0px)',
        styleClass: "vs-modal vs-file-viewer",
        contentStyle: { 'overflow': 'auto' }, //'max-height': 'calc(100vh - 180px);', 
        baseZIndex: 1100,
        closeOnEscape: true
      });
    }
  }

  async downloadFile(item: any) {
    var url = `${environment.apiDomain.fileEndpoint}/${item.path}`;
    //if (item.extention == ".jpeg" || item.extention == ".png" || item.extention == ".jpg" || item.extention == ".bmp" || item.extention == ".gif" || item.extention == ".bmp" || item.extention == ".apng" || item.extention == ".ico" || item.extention == ".webp" || item.extention == ".avif")
    if (item.type == 1)
      url = `${environment.apiDomain.fileEndpoint}/Original/${item.path}`;

    fetch(url)
      .then(async (response) => {
        const blob = await response.blob();

        const urlDownload = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = urlDownload;
        link.setAttribute("download", item.fileName);
        link.click();
      }
      )
    return false;
  }

  downloadFileAll() {
    this.listUploaded.forEach(element => {
      this.downloadFile(element);
    });
  }

}
